import React, { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import API_URL from '../config/api';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Validate passwords match
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    // Validate password length
    if (password.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          token, 
          password, 
          confirmPassword 
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || "Failed to reset password");
      }

      setSuccess("Password has been reset successfully! You will be redirected to login in 3 seconds.");
      setPassword("");
      setConfirmPassword("");

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setError(err.message || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 pb-4">
            Create new password
          </h2>
          <p className="text-center text-gray-600">
            Enter your new password below to complete the password reset.
          </p>
        </div>

        {error && (
          <div className="bg-red-100 text-red-700 p-4 rounded mb-4">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-100 text-green-700 p-4 rounded mb-4">
            {success}
          </div>
        )}

        <div className="d-flex justify-content-center align-items-center">
          <form
            className="w-100"
            style={{ maxWidth: "550px" }}
            onSubmit={handleSubmit}
          >
            <div className="rounded-md justify-center shadow-sm -space-y-px">
              <div>
                <label htmlFor="password" className="sr-only py-2 fs-5">
                  New Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control mb-2 py-3"
                  placeholder="New Password"
                  disabled={loading}
                  minLength="6"
                />
              </div>
              <div>
                <label htmlFor="confirm-password" className="sr-only py-2 fs-5">
                  Confirm Password
                </label>
                <input
                  id="confirm-password"
                  name="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="form-control mb-2 py-3"
                  placeholder="Confirm Password"
                  disabled={loading}
                  minLength="6"
                />
              </div>
            </div>

            <div className="text-sm text-gray-600 mb-3 mt-2">
              <p>Password must be at least 6 characters long</p>
            </div>

            <div>
              <button 
                type="submit" 
                className="btn btn-primary w-100 py-3 mt-4 fs-5"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </div>

            <div className="text-center mt-4">
              <p className="text-gray-600">
                <Link to="/login" className="text-blue-600 hover:text-blue-800">
                  Back to login
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
